namespace GeniuzPOS.Purchase {
    export class ReportDailyCNColumns {
        static columnsKey = 'Purchase.ReportDailyCN';
    }
}
